import debugLog from '@/debug-log-script-name.js'

$(function() {
  const activityAvatar = $('.activity-avatar')
  debugLog(activityAvatar, 'avatar-preview.js') // DEBUG
  activityAvatar.each(function() {
    const $el = $(this),
      $colorInput = $el.find('[name="Color"]'),
      $refInput = $el.find('[name="Abbreviation"]'),
      $preview = $el.find('.activity-label')

    $colorInput.on('change', function() {
      $preview.css('background-color', $(this).val())
    })

    $refInput.on('change keyup', function() {
      $preview.text($(this).val())
    })
  })
})
